const getOverlay = (state) => {
	return state.overlay;
};

export default {
	getOverlay
};
